var _path, _rect, _rect2, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 364,
    height: 360,
    viewBox: "0 0 364 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122 298L122 68L252 68L312 128L312 298L122 298Z",
    fill: "#E7E7E7"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 166,
    width: 90,
    height: 16,
    fill: "#D1D1D1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 212,
    width: 60,
    height: 16,
    fill: "#D1D1D1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M252 128L252 68L312 128L252 128Z",
    fill: "#D1D1D1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M182 236C182 221.678 176.311 207.943 166.184 197.816C156.057 187.689 142.322 182 128 182C113.678 182 99.9432 187.689 89.8162 197.816C79.6893 207.943 74 221.678 74 236C74 250.322 79.6893 264.057 89.8162 274.184C99.9432 284.311 113.678 290 128 290C142.322 290 156.057 284.311 166.184 274.184C176.311 264.057 182 250.322 182 236Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53 348C53 325.909 70.9086 308 93 308H163C185.091 308 203 325.909 203 348V360H53V348Z",
    fill: "#D1D1D1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.995 290C127.997 290 127.998 290 128 290C128.002 290 128.003 290 128.005 290C142.325 289.999 156.058 284.31 166.184 274.184C176.311 264.057 182 250.322 182 236C182 221.678 176.311 207.943 166.184 197.816C156.057 187.689 142.322 182 128 182C125.986 182 123.983 182.113 122 182.334L122 289.666C123.981 289.887 125.982 290 127.995 290Z",
    fill: "#304FF2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M148 236H182C182 245.757 179.359 255.243 174.473 263.5C156.052 263.5 149.149 245.167 148 236Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.a69500f47023d3b8632674912bebac0b.svg";
export { ForwardRef as ReactComponent };